import { Input } from "@itandi/itandi-bb-ui";
import type { ForwardedRef, MutableRefObject, RefAttributes } from "react";
import React from "react";
import { useDebounce } from "~/hooks/useDebounce";

type Props = {
	debounceDelay?: number;
	defaultValue?: string;
	handleChange: (searchWord: string) => void | Promise<void>;
	placeholder?: string; // useCallbackでWrapすること
};

export const SearchInput: React.FC<Props & RefAttributes<HTMLInputElement>> =
	React.forwardRef(
		(
			{
				placeholder,
				debounceDelay = 200,
				defaultValue = "",
				handleChange
			}: Props,
			ref: MutableRefObject<HTMLInputElement> | ForwardedRef<HTMLInputElement>
		) => {
			const [searchWord, setSearchWord] = React.useState<string>(defaultValue);
			const debounce = useDebounce(debounceDelay);
			const onChangeWord = (e: React.ChangeEvent<HTMLInputElement>): void => {
				const inputValue = e.target.value;
				setSearchWord(inputValue);
				debounce(() => {
					handleChange(inputValue);
				});
			};
			return (
				<Input
					onChange={onChangeWord}
					placeholder={placeholder}
					ref={ref}
					type="search"
					value={searchWord}
				/>
			);
		}
	);
